import createCollectionResource from 'src/actions/shared/createResource';
import { HttpLog } from 'src/actions/httpLogs/httpLogsTypes';
import emptyObserverCreator from 'src/actions/shared/emptyObserverCreator';

const httpLogsResource = createCollectionResource<HttpLog>({
  name: 'httpLogs',
  endpoint: 'v1/orgs/:orgId/httplogs',
  observerCreator: emptyObserverCreator,
  options: {
    doNotSubscribe: true,
  },
});

export default httpLogsResource;
